var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgReload = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 52,
  height: 52,
  viewBox: "0 0 52 52"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Styles-v2",
  fill: "none",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: 1
}, /*#__PURE__*/React.createElement("g", {
  id: "Reload",
  fill: "#DFC991"
}, /*#__PURE__*/React.createElement("path", {
  id: "$-",
  d: "M27.872 2C40.652 2 51.02 12.586 51.02 25.573S40.653 49.145 27.872 49.145c-10.939 0-20.11-7.768-22.524-18.148a1.432 1.432 0 1 1 2.79-.648c2.124 9.136 10.146 15.939 19.734 15.939 11.206 0 20.29-9.243 20.29-20.715 0-11.473-9.084-20.716-20.29-20.716-8.852 0-16.377 5.77-19.153 13.84l3.995-2.031a1.429 1.429 0 1 1 1.295 2.545L7.022 22.76a1.43 1.43 0 0 1-1.897-.558l-3.929-7.01A1.43 1.43 0 0 1 2.58 13.05c.471.045.889.321 1.116.736l2.3 4.108C9.123 8.654 17.734 2 27.872 2"
})))));
export default SvgReload;